<div class="bk-page tpl">
  <header class="bk-page__head">
    <div class="bk-page__intro">
      <p class="bk-eyebrow">Templates</p>
      <h1 class="bk-page__title">{{ templateId ? "Edit template" : "New template" }}</h1>
      <p class="bk-page__sub">
        Save copy you send often. Personalised fields fill in for each contact when the template is used in a message.
      </p>
    </div>
    <div class="bk-page__actions">
      <button type="button" class="bk-btn bk-btn--ghost" (click)="handleBack()">
        <span class="bk-sym" aria-hidden="true">arrow_back</span>
        Templates
      </button>
    </div>
  </header>

  <!-- Always rendered: its live regions must already be in the page to announce a message. -->
  <feedback-card [message]="feedbackMessage" [feedBackType]="feedbackType" />

  <form class="tpl__grid" [formGroup]="templateForm" (ngSubmit)="onSubmit()">
    <!-- ── Editor ── -->
    <section class="bk-panel tpl__panel" aria-labelledby="tpl-editor-title" [attr.aria-busy]="loadingTemplate">
      <h2 class="bk-eyebrow" id="tpl-editor-title">Template</h2>

      @if (loadingTemplate) {
        <div class="tpl__skel" aria-hidden="true">
          <span class="bk-skel" style="height: 44px"></span>
          <span class="bk-skel" style="height: 44px"></span>
          <span class="bk-skel" style="height: 150px; grid-column: 1 / -1"></span>
        </div>
        <span class="bk-sr-only">Loading the template</span>
      } @else {
        <div class="tpl__row">
          <input-field
            label="Name"
            hint="How you find it in the template list."
            [errorMessage]="submitted && templateForm.get('templateName')?.invalid ? 'Give the template a name.' : ''"
          >
            <input
              placeholder="For example, Payment reminder"
              formControlName="templateName"
              class="input-style"
              autocomplete="off"
            />
          </input-field>

          <input-field
            label="Category"
            [errorMessage]="submitted && templateForm.get('category')?.invalid ? 'Choose a category.' : ''"
          >
            <select formControlName="category" class="input-style">
              <option value="" disabled>Choose a category</option>
              @for (option of categories; track option) {
                <option [value]="option">{{ option }}</option>
              }
            </select>
          </input-field>
        </div>

        <input-field
          label="Message"
          [errorMessage]="submitted && textareaControl.invalid ? 'Write the message this template holds.' : ''"
        >
          <div class="tpl__body">
            <textarea
              #bodyInput
              name="body"
              id="body"
              rows="7"
              class="input-style tpl__textarea"
              placeholder="Write the message. Use the field button to add each contact's name or other details."
              [formControl]="textareaControl"
            ></textarea>
            <message-attribute-menu (select)="appendAttribute($event)"></message-attribute-menu>
          </div>
        </input-field>

        <message-attribute-chips
          [message]="content"
          [costHint]="false"
          (remove)="removeAttribute($event)"
        ></message-attribute-chips>

        <compose-sms-meter class="tpl__meter" [text]="content" />
      }

      <div class="tpl__actions">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="handleBack()">Cancel</button>
        <button
          type="submit"
          class="bk-btn bk-btn--primary"
          [disabled]="saveDisabled"
          [attr.aria-busy]="loading"
        >
          @if (loading && !loadingTemplate) {
            Saving…
          } @else {
            {{ templateId ? "Save changes" : "Save template" }}
          }
        </button>
      </div>
    </section>

    <!-- ── Preview ── -->
    <aside class="bk-panel tpl__preview" aria-labelledby="tpl-preview-title">
      <header class="tpl__preview-head">
        <h2 class="bk-eyebrow" id="tpl-preview-title">Preview</h2>
        <span class="tpl__category">{{ category || "No category yet" }}</span>
      </header>

      <div class="tpl__phone">
        <p class="tpl__name" [class.is-empty]="!template_name">{{ template_name || "Untitled template" }}</p>
        <bk-sms-bubble
          class="tpl__bubble"
          variant="compact"
          [text]="content.trim() ? content : ''"
          [clamp]="16"
          emptyText="Start writing and the message appears here the way a phone shows it."
        />
      </div>
    </aside>
  </form>
</div>
